import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniPujcovnaVozidlo = {
	name: NAME,
	apiProvider,
	router,
};
